import deriveLinkComponents from '../../associations/derive-link-components';
import api from '../../REST/api';
import ContactListLink from './ContactListLink';

const { Link, Links } = deriveLinkComponents(
  ContactListLink,
  api.getContactList,
);

export { Link as ContactListLink, Links as ContactListLinks };
